(function () {
  'use strict';

  angular
    .module('biReport')
    .config(function ($stateProvider) {
      return $stateProvider.state('root.biReport', {
        url: '/bi-report?vfiltro=',
        views: {
          'content@': {
            templateUrl: 'configuracoes/bi-report/bi-report.tpl.html',
            controller: 'BIReportCtrl',
            controllerAs: 'ctrl'
          }
        },
        data: {
          titulo: 'ce.configuracao.biReport.title',
          tituloDescricao: '',
          role: 'ADMIN_VELTEC'
        }
      });
    });
}());
